
import './styles.css'
import {
  RouterProvider, 
  createBrowserRouter, 
  createRoutesFromElements, 
  Route
} from "react-router-dom"

import Home from '../Pages/public/Home'
import Layout from '../Pages/public/Layout'

import FAQ from '../Pages/public/FAQ'
import Events from '../Pages/public/Events'
import eventsLoader from '../functions/eventsLoader'
import EventSingle,{loader as singleEventLoaderFE} from '../Pages/public/EventSingle'
import Support from '../Pages/public/Support'
import Contact from '../Pages/public/Contact'
import ErrorElement from '../Pages/public/ErrorElement'
import EventsError from '../Pages/public/EventsError'

import AdminLayout from '../Pages/admin/AdminLayout'
import Login, {Loader as loginLoader, Action as loginAction} from '../Pages/admin/Login'
import Register, {Loader as registerLoader, Action as registerAction} from '../Pages/admin/Register'
import Posts, {Loader as eventLoader} from '../Pages/admin/Posts'
import NewPost, {Loader as singleEventLoader} from '../Pages/admin/NewPost'
import ErrorElementBackEnd from '../Pages/admin/ErrorElement'




const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Layout />}> 
        <Route index element={<Home />} errorElement={<ErrorElement />}/>
        <Route path='FAQ' element={<FAQ/>}/>
        <Route path='events' 
          element={<Events />} 
          loader={eventsLoader}
          errorElement={<EventsError/>}
          hydrateFallbackElement={<p>Loading...</p>}
        />
        <Route path='events/:eventID' 
          element={<EventSingle />} 
          loader={singleEventLoaderFE}
          hydrateFallbackElement={<p>Loading...</p>}
        />
        <Route path='contact' element={<Contact/>}/>
        <Route path='support' element={<Support />}/>

      </Route>
      <Route path="admin" 
        element={<AdminLayout/>}
      >
        <Route index element={<Login />} 
          action={loginAction} 
          loader={loginLoader}
          errorElement={<ErrorElementBackEnd />}
        />
        <Route path="register"
          element={<Register />} 
          action={registerAction} 
          loader={registerLoader}
          errorElement={<ErrorElementBackEnd />}
        />
        <Route path="posts" 
          element={<Posts />} 
          loader={eventLoader}
          errorElement={<ErrorElementBackEnd />}
          hydrateFallbackElement={<p>Loading...</p>}
        />
        <Route path="new-post" 
          element={<NewPost />} 
          loader={singleEventLoader}
          errorElement={<ErrorElementBackEnd />}
          hydrateFallbackElement={<p>Loading...</p>}
        />
        <Route 
          path="/admin/new-post/:eventID" 
          element={<NewPost />} 
          loader={singleEventLoader}
          hydrateFallbackElement={<p>Loading...</p>}
        />
      </Route>
    </>
));

function App() {
  return (
    <RouterProvider router={router} />
  )
}

export default App